import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { Observable } from 'rxjs';

import { RoutesByType, RouteEntity } from '../../schedule.model';
import { SchedulePartialStoreState } from '../schedule.reducer';
import { RoutesActions } from './routes.action';
import * as RoutesSelector from './routes.selectors';

@Injectable()
export class RoutesFacade {
    selectedRouteId$: Observable<number> = this.store.select(RoutesSelector.getSelectedRouteId);
    routeListDates$: Observable<string[]> = this.store.select(RoutesSelector.getDates);
    allRoutes$: Observable<RouteEntity> = this.store.select(RoutesSelector.getRouteEntities);
    loading$: Observable<boolean> = this.store.select(RoutesSelector.getLoading);
    routes$: Observable<any> = this.store.select(RoutesSelector.getRoutes);
    ids$: Observable<number[]> = this.store.select(RoutesSelector.getIds);

    constructor(private store: NgRedux<SchedulePartialStoreState>, private actions: RoutesActions) {}

    fetchAllStopsWithRoutes(): void {
        this.store.dispatch(this.actions.fetchAllStopsWithRoutes());
    }

    fetchAllRoutes(): void {
        this.store.dispatch(this.actions.fetchAllRoutes());
    }

    setSelectedRouteId(id: number): void {
        this.store.dispatch(this.actions.setSelectedRouteId(id));
    }

    getRoutesByType(dates: string[]): Observable<RoutesByType> {
        return this.store.select(RoutesSelector.getRouteIdsByDate(this.getPackageDate(dates)));
    }

    private getPackageDate(dates: string[]): string {
        const today = new Date();
        let i = 0;
        let packageDate = dates[i];

        while (dates[i] !== undefined) {
            if (today > new Date(dates[i]) && packageDate < dates[i]) {
                packageDate = dates[i];
            }
            i++;
        }

        return packageDate;
    }
}
